export default "__VITE_ASSET__03b964f9__"